import { render, staticRenderFns } from "./flightTypeList.vue?vue&type=template&id=5690a4ec&scoped=true&"
import script from "./flightTypeList.vue?vue&type=script&lang=js&"
export * from "./flightTypeList.vue?vue&type=script&lang=js&"
import style0 from "./flightTypeList.vue?vue&type=style&index=0&id=5690a4ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5690a4ec",
  null
  
)

export default component.exports